import UserList from "./components/List"
import UserForm from "./components/Form"
import UserView from "./components/View"
import UserRoles from "./components/Roles"
import Profile from "./components/Profile"

let module = "users"

export default [
  { path: "users", component: UserList, meta: { module: module, permissions: ["user-access"] } },
  { path: "users/create", component: UserForm, props: true, meta: { module: module, permissions: ["user-create"] } },
  { path: "users/edit/:id", component: UserForm, props: true, meta: { module: module, permissions: ["user-access"] } },
  { path: "users/view/:id", component: UserView, props: true, meta: { module: module, permissions: ["user-access"] } },
  { path: "users/roles/:id", component: UserRoles, props: true, meta: { module: module, permissions: ["user-edit"] } },
  { path: "profile", component: UserForm, meta: { module: module, permissions: ["user-access"] } }
]
